<template>
  <div id="Location" :class="isbor?'borderBottom':''">
        您的位置:
         <span @click="routerBack(val.toPath)" v-for="(val,index) in locationList" :key="index" >{{ val.name}} <span class="location_logo"></span></span>
  </div>
</template>
<script>
export default {
  name: "Location",
  props: [
    "isbor",
  ],
  data() {
    return {
      locationList:[]
    };
  },
  created() {
    console.log(this.$route,'555555555')
    this.getBreadcrumbList(this.$route.matched);
  },
  methods: {
    // 获取面包屑数据
    getBreadcrumbList(matched) {
      console.log("matched", matched);
      const list = matched.filter((item) => {
        return !item.meta.notBreadcrumb;
      });
      list.forEach((item) => {
        if (item.redirect) {
          item.toPath = item.redirect;
        } else {
          item.toPath = item.path;
        }
      });
      this.locationList = list;
    },
    routerBack(toPath) {
      if (this.$route.path == toPath) {
          return
      }
      if (!toPath) {
        this.$router.push({  path: '/' })
      } else {
        this.$router.push({  path: toPath })
      }
     
    }
  }
};
</script>
<style scoped>
#Location{
  width: 100%;
  height: 70px;
  line-height: 70px;
  /* padding: 0 20px 20px 20px; */
  margin: 20px 0;
  padding: 0 30px;
 
  font-size: 16px;
  color: #999999;
  background: #fff;
}
.borderBottom{
  border-bottom: 1px solid #EEEEEE;
}
#Location span{
  cursor: pointer;
}
#Location span:hover{
  color: #E1892A;
}

#Location span:nth-last-child(1){
  color: #E1892A;
}
#Location span:nth-last-child(1) .location_logo{
  display: none;
}
#Location .location_logo{
  padding: 0 10px;
  display: inline-block;
  background: url(../../public/img/m2pos_ar.png) no-repeat center center;
  height: 20px;
  width: 20px;
  background-size: 20px;
  position: relative;
  top: 5px;
 
}

</style>



// WEBPACK FOOTER //
// src/components/Location.vue